module.exports = __webpack_public_path__ + "img/w_js@2x.89cb9381.png";